import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from 'react-progressive-image';
import Observer from 'react-intersection-observer';
import { get, getOr, isArray } from 'lodash/fp';

import withRestProps from 'helpers/withRestProps';

class LazyImage extends PureComponent {
  static propTypes = {
    alt: PropTypes.string,
    isLazy: PropTypes.bool,
    placeholder: PropTypes.string,
    rest: PropTypes.object.isRequired,
    src: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  };

  static defaultProps = {
    isLazy: true,
  };

  state = {
    srcIndex: 0,
    isIntersected: false,
  };

  getImageSrc = () => {
    const { src } = this.props;

    if (isArray(src)) {
      const { srcIndex } = this.state;

      return getOr('', [srcIndex], src);
    }

    return src;
  };

  handleImageLoadError = () => {
    const { src } = this.props;

    if (isArray(src)) {
      const { srcIndex } = this.state;
      const nextSrcIndex = srcIndex + 1;
      const nextSrcImage = get([nextSrcIndex], src);

      if (nextSrcImage) {
        this.setState({ srcIndex: nextSrcIndex });
      }
    }
  };

  handleObserverChange = (isIntersecting) => {
    if (isIntersecting) {
      this.setState({
        isIntersected: true,
      });
    }
  };

  renderImage = (src) => {
    const { alt, rest } = this.props;

    return src ? <img {...rest} alt={alt} src={src} /> : null;
  };

  render() {
    const { isIntersected } = this.state;
    const { placeholder, isLazy } = this.props;

    if (isLazy && !isIntersected) {
      return (
        <Observer threshold={0} onChange={this.handleObserverChange}>
          {this.renderImage(placeholder)}
        </Observer>
      );
    }

    return (
      <ProgressiveImage
        src={this.getImageSrc()}
        placeholder={placeholder}
        onError={this.handleImageLoadError}
      >
        {this.renderImage}
      </ProgressiveImage>
    );
  }
}

export default withRestProps()(LazyImage);
